function parseGoogleLatLng(latLng) {
    return {
        lat: latLng.lat(),
        lng: latLng.lng(),
    };
}

export default parseGoogleLatLng;
